import { Component, Output, EventEmitter, OnInit, Input, SimpleChanges } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { Product, ProductCreatePayload, ProductUpdatePayload } from '@mira-avant/mtlibs';
import { AppModule } from '../../../../modules/app.module';
import { ZorroModule } from '../../../../modules/zorro.module';
import { ThirdPartyModule } from '../../../../modules/third-party.module';
import { AngularModule } from '../../../../modules/angular.module';
import { FormTitleComponent } from '../../../ui/forms/form-title/form-title.component';
import { TextFieldComponent } from '../../../fields/standard/text-field/text-field.component';
import { EngineDropdownField } from '../../../fields/standard/engine-dropdown-field/engine-dropdown-field';

@Component({
	selector: 'app-product-form',
	standalone: true,
	imports: [
		AppModule,
		ZorroModule,
		ThirdPartyModule,
		AngularModule,
		FormTitleComponent,
		TextFieldComponent,
		EngineDropdownField,
	],
	templateUrl: './product-form.html',
	styleUrl: './product-form.scss',
})
export class ProductForm implements OnInit {
	@Input('product') public product: Product | undefined | null;
	@Output('onSubmit') public onSubmitEmitter: EventEmitter<Product> = new EventEmitter<Product>();

	public form: FormGroup = this.fb.group({
		name: ['', [Validators.required, Validators.maxLength(255)]],
		engine_name: ['', [Validators.required, Validators.maxLength(255)]],
	});

	constructor(private fb: FormBuilder) {}

	ngOnInit(): void {}

	ngOnChanges(changes: SimpleChanges): void {
		if (changes['product'] && this.product) {
			this.form.patchValue({
				name: this.product.name,
				engine_name: this.product.engine_name,
			});
		}
	}

	public async onSubmit(): Promise<void> {
		if (this.form.invalid) {
			console.error('Form is invalid', this.form.errors);
			return;
		}

		const payload: ProductCreatePayload | ProductUpdatePayload = this.form.value;

		try {
			this.onSubmitEmitter.emit(this.form.value);
			this.clear();
		} catch (error) {
			console.error('Error submitting form:', error);
		}
	}

	public clear(): void {
		this.form.reset({});
	}
}
